// Collection Grid Image Fix - AGGRESSIVE
// Forces product images to display at full width on collection pages

document.addEventListener('DOMContentLoaded', function() {
  // Only run on collection pages
  if (!document.body.classList.contains('template-collection')) {
    return;
  }

  // Function to aggressively fix card media widths
  function forceFullWidthImages() {
    // First, remove any horizontal card classes
    const horizontalCards = document.querySelectorAll('.template-collection .card--horizontal');
    horizontalCards.forEach(function(card) {
      card.classList.remove('card--horizontal');
    });
    
    // Find all card media elements
    const cardMediaElements = document.querySelectorAll('.card__media');
    
    cardMediaElements.forEach(function(media) {
      // Remove ALL inline styles
      media.removeAttribute('style');
      
      // Force width through JavaScript
      media.style.width = '100%';
      media.style.maxWidth = '100%';
      media.style.minWidth = '100%';
      media.style.margin = '0';
      media.style.padding = '0';
      media.style.transform = 'none';
      media.style.left = '0';
      media.style.right = '0';
      media.style.position = 'relative';
      
      // Override any CSS variables
      media.style.setProperty('--image-padding', '0', 'important');
      media.style.setProperty('width', '100%', 'important');
      
      // Check computed style and force override if needed
      const computedWidth = window.getComputedStyle(media).width;
      const parentWidth = media.parentElement.offsetWidth;
      if (parseFloat(computedWidth) < parentWidth * 0.9) {
        media.style.cssText = 'width: 100% !important; max-width: 100% !important; margin: 0 !important; padding: 0 !important;';
      }
      
      // Fix all parent elements
      let parent = media.parentElement;
      while (parent && !parent.classList.contains('grid__item')) {
        parent.style.width = '100%';
        parent.style.maxWidth = '100%';
        parent.style.overflow = 'visible';
        parent = parent.parentElement;
      }
      
      // Fix child media elements
      const innerMedia = media.querySelector('.media');
      if (innerMedia) {
        innerMedia.style.width = '100%';
        innerMedia.style.maxWidth = '100%';
      }
      
      // Fix images
      const images = media.querySelectorAll('img');
      images.forEach(function(img) {
        img.style.width = '100%';
        img.style.maxWidth = '100%';
        img.style.height = '100%';
        img.style.objectFit = 'cover';
      });
    });
    
    // Also check for any elements with inline width styles
    const elementsWithWidth = document.querySelectorAll('[style*="width"]');
    elementsWithWidth.forEach(function(element) {
      if (element.closest('.card__media') || element.classList.contains('card__media')) {
        const currentStyle = element.getAttribute('style');
        if (currentStyle && (currentStyle.includes('width: 50%') || currentStyle.includes('width:50%'))) {
          element.style.width = '100%';
        }
      }
    });
  }

  // Run multiple times to ensure it catches everything
  forceFullWidthImages();
  setTimeout(forceFullWidthImages, 100);
  setTimeout(forceFullWidthImages, 500);
  setTimeout(forceFullWidthImages, 1000);

  // Monitor for changes
  const observer = new MutationObserver(function(mutations) {
    forceFullWidthImages();
  });

  // Observe the entire document for any changes
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class']
  });

  // Fix on various events
  window.addEventListener('load', forceFullWidthImages);
  window.addEventListener('resize', forceFullWidthImages);
  document.addEventListener('shopify:section:load', forceFullWidthImages);
  document.addEventListener('shopify:section:reorder', forceFullWidthImages);

  // Debug function - ACTIVE for troubleshooting
  window.debugCards = function() {
    console.log('=== CARD LAYOUT DEBUG ===');
    const cards = document.querySelectorAll('.template-collection .card');
    cards.forEach(function(card, index) {
      const media = card.querySelector('.card__media');
      const content = card.querySelector('.card__content');
      const inner = card.querySelector('.card__inner');
      
      console.log('Card ' + index + ':', {
        cardClasses: card.className,
        hasHorizontal: card.classList.contains('card--horizontal'),
        cardWidth: card.offsetWidth,
        innerWidth: inner ? inner.offsetWidth : 'no inner',
        mediaWidth: media ? media.offsetWidth : 'no media',
        contentWidth: content ? content.offsetWidth : 'no content',
        display: window.getComputedStyle(card).display,
        flexDirection: window.getComputedStyle(card).flexDirection
      });
      
      if (media) {
        console.log('  Media styles:', {
          computedWidth: window.getComputedStyle(media).width,
          display: window.getComputedStyle(media).display,
          float: window.getComputedStyle(media).float,
          inlineStyle: media.getAttribute('style')
        });
      }
    });
  };
  
  // Auto-run debug on load
  setTimeout(function() {
    console.log('Auto-debugging card layout...');
    window.debugCards();
  }, 2000);
});